// AXIS ZERO - Level Generator Module
// Pattern-based level generation: SAFE → SKILL → TWIST with early game fairness

import { CONFIG, PATTERNS } from './Config';

export class LevelGenerator {
  constructor() {
    this.patternIndex = 0;
    this.gameTime = 0;
    this.twistEnabled = false;
    this.obstacleCount = 0;
  }

  reset() {
    this.patternIndex = 0;
    this.gameTime = 0;
    this.twistEnabled = false;
    this.obstacleCount = 0;
  }

  update(deltaTime) {
    this.gameTime += deltaTime;
    
    // Enable twist patterns after threshold time
    if (!this.twistEnabled && this.gameTime >= CONFIG.FIRST_TWIST_TIME) {
      this.twistEnabled = true;
    }
  }

  getNextPattern() {
    const patternCycle = CONFIG.PATTERN_CYCLE;
    let patternName = patternCycle[this.patternIndex % patternCycle.length];
    
    // Early game fairness: first 5 seconds favor SAFE patterns
    if (this.gameTime < CONFIG.EARLY_GAME_DURATION) {
      // Force SAFE pattern for first ~5 seconds
      if (patternName !== 'SAFE') {
        patternName = 'SAFE';
      }
    } else {
      // Skip TWIST if not yet enabled
      if (patternName === 'TWIST' && !this.twistEnabled) {
        patternName = 'SKILL'; // Fallback to SKILL until TWIST is enabled
      }
    }
    
    const pattern = PATTERNS[patternName];
    
    // Advance pattern index
    this.patternIndex++;
    this.obstacleCount++;
    
    return {
      ...pattern,
      name: patternName,
      index: this.obstacleCount,
      gameTime: this.gameTime,
    };
  }

  // Get current difficulty multiplier based on game time
  getDifficultyMultiplier() {
    // Gradually increase difficulty
    const baseMultiplier = 1;
    const timeBonus = Math.min(this.gameTime / 60, 0.5); // Max 50% increase over 60 seconds
    return baseMultiplier + timeBonus;
  }

  // Get current speed based on game time
  getCurrentSpeed(isPracticeMode = false) {
    const baseSpeed = CONFIG.START_SPEED;
    const maxSpeed = CONFIG.MAX_SPEED;
      const k = 0.03; // ease-out rate (tune later)
      let speed = baseSpeed + (maxSpeed - baseSpeed) * (1 - Math.exp(-k * this.gameTime));
      speed = Math.min(speed, maxSpeed);
    
    if (isPracticeMode) {
      speed *= CONFIG.PRACTICE_SPEED_MULT;
    }
    
    return speed;
  }

  // Get speed multiplier for trail effects
  getSpeedMultiplier() {
    const currentSpeed = this.getCurrentSpeed();
    return currentSpeed / CONFIG.START_SPEED;
  }

  getGameTime() {
    return this.gameTime;
  }

  isTwistEnabled() {
    return this.twistEnabled;
  }

  isEarlyGame() {
    return this.gameTime < CONFIG.EARLY_GAME_DURATION;
  }
}

export default LevelGenerator;
